import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { persistor } from 'src/store/Store';

const initialState = {
    lessonDetail: null,
    lvlLesson: null,
};


export const LessonSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        getLessonDetails: (state, action) => {
            return {
                ...state,
                lessonDetail: action.payload
            };
        },
        getLevelLessons: (state, action) => {
            return {
                ...state,
                lvlLesson: action.payload
            };
        },
    },
});

export const getLessonDetail = (type, auth, id) => async (dispatch) => {
    const authConfig = {
        headers: { Authorization: `Bearer ${auth.token}`, email: auth.email },
    };
    if (type == 'USER') {
        axios
            .get(`https://backend.sophtomeng.com/contents/lessons/detail/${id}`, authConfig)
            .then((response) => {
                console.log(response.data);
                dispatch(getLessonDetails(response.data))
            }
            )
            .catch(function (error) {
                console.log(error);
            });
    }
}


export const getLevelLesson = (type, auth, formData) => async (dispatch) => {
    console.log("girdi", auth);

    const authConfig = {
        headers: { Authorization: `Bearer ${auth.token}`, email: auth.email },
        params: { level_id: formData.get("level_id") },
    };
    if (type == 'USER') {
        axios
            .get(`https://backend.sophtomeng.com/contents/lessons/user`,  authConfig)
            .then((response) => {
                console.log(response.data);
                dispatch(getLevelLessons(response.data))
            }
            )
            .catch(function (error) {
                console.log(error);
            });
    }
}




export const {
    getLessonDetails,
    getLevelLessons
} = LessonSlice.actions;

export default LessonSlice.reducer;
